export const environment = {
    env: "qa",
    version: "R96",
    address: "400 Capitol Mall, Suite 1200\nSacramento, CA 95814",
    analytics: "UA-18062737-1",
    quoterApi: "https://quoter-qa.earthquakeauthority.com/api/Quote/",
    spatialApi: "https://spatial-qa.earthquakeauthority.com/api/verifysimple?suiteLineOne=true",
    spatial_subscriber_key: "d36015fb-a093-4956-b040-52080ceec42e",
    quoterPort: 443,
    homeownerEndpoint: "CalculateQuoteHome",
    renterEndpoint: "CalculateQuoteRenter",
    condoEndpoint: "CalculateQuoteCondo",
    mobileEndpoint: "CalculateQuoteMobile",
    ocp_apim_subscription_key: "7aa6c44221184a5fad91cc425ddec270",
    apiUrl: "https://calc-qa.earthquakeauthority.com",
    urireport: "/api/Pdf/quote",
    urireportkey: "9603ab5ac5524f2aa8b3d31011b9c9d0",
    zipcodeurl: "https://quoter-qa.earthquakeauthority.com/api/ZipCodes/detail",
    pilisturl: "https://quoter-qa.earthquakeauthority.com/api/Pi",
    timerurl: "/api/timer",
    translationurl: "/api/translation",
    languageurl: "/api/Language/Get?language=",
    clientId: "2b58f212-bbbb-4e20-b818-ac9138ee369b",
    authority: "https://login.microsoftonline.com/9b6ce1d3-1230-48ac-a353-0c58a56eaf66",
    redirectUri: "https://calc-qa.earthquakeauthority.com/admin",
    protectedurl: "/api/translation",
    protectedapi: "api://52e45d80-db6f-43eb-9037-d3df000d502f/translation.access",
    eqasiteurl: "https://qa.earthquakeauthority.com",
    participatinginsurersurl: "/California-Earthquake-Insurance-Policies/Participating-Residential-Insurers-Earthquake",
    browsersupporturl: "/california-earthquake-insurance-policies/earthquake-insurance-premium-calculator/browser-compatibility",
    Grantsurl: "/California-Earthquake-Insurance-Policies/Earthquake-Insurance-Policy-Premium-Discounts/Brace-and-Bolt-Seismic-Retrofit-Grants",
    riskpreparednessurl: "/Prepare-Your-House-Earthquake-Risk",
    addressConfirm: true,
    quoter2027Service: {
        startDate: "1/1/2027",
        endDate: "12/31/2027",
        dateToEnableRates: "12/31/2026",
        version: "V6"
    },
    quoter2026Service: {
        startDate: "1/1/2026",
        endDate: "12/31/2026",
        dateToEnableRates: "7/1/2025",
        version: "V6"
    },
    quoter2025Service: {
        startDate: "1/1/2025",
        endDate: "12/31/2025",
        dateToEnableRates: "9/1/2024",
        version: "V6"
    },
    quoter2024Service: {
        startDate: "8/1/2024",
        endDate: "12/31/2025",
        dateToEnableRates: "8/1/2024",
        version: "V5"
    },
    quoter2023Service: {
        startDate: "9/1/2024",
        endDate: "12/31/2024",
        dateToEnableRates: "3/26/2024",
        version: "V5",
    },
    quoter2022Service: {
        startDate: "11/1/2023",
        endDate: "12/31/2024",
        dateToEnableRates: "1/1/2023",
        version: "V4"
    },
    quoter2021Service: {
        dateToEnable2022Rates: "1/1/2022",
        startDate: "1/1/2022",
        endDate: "3/31/2023",
        dateToEnableRates: "1/1/2022",
        version: "V4",
    },
    quoter2020Service: {
        startDate: "1/1/2021",
        endDate: "3/31/2022",
        dateToEnableRates: "1/1/2021",
        version: "V4"
    },
    quoter2019Service: {
        dateToEnable2020Rates: "1/1/2019",
        dateToEnable2021Rates: "1/1/2019",
        startDate: "7/1/2020",
        endDate: "12/31/2020",
        dateToEnableRates: "5/1/2018",
        version: "V4"
    },
    quoter2016Service: {
        startDate: "1/1/2016",
        endDate: "6/30/2019",
        dateToEnableRates: "1/1/2016",
        version: "V3"
    }
}
